// extracted by mini-css-extract-plugin
module.exports = {"errors":"index_errors_3c6pE","container":"index_container_1HT1g","footerNav":"index_footerNav_2K957"};